import BasicLayout from '@/layouts/basic-layout';
////第一步：配置菜单-->第二步：配置存房委托指派评估页面相关的路由-->第三步：注入路由-->第四步：做页面
const meta = {
	auth: true
};

const pre = 'khm-';

export default {
	path: '/khm',
	name: '派单管理',//商家运营指派评估
	redirect: {
		name: `${pre}houseSaveDelegationAssessmentCompany-list`
	},
	meta,
	component: BasicLayout,
	children: [{
		path: 'houseSaveDelegationAssessmentCompany-list',
		name: `${pre}houseSaveDelegationAssessmentCompany-list`,
		meta: {
			...meta,
			title: '派单管理',
			closable: true
		},
		component: () => import('@/pages/storagemanage/houseSaveDelegationAssessmentCompany/index')
	}]
};
